import axios from '../../../axios'


// 获取待处理业务
export const getWaitTasks = (data) => {
  return axios({
    url: '/home/data/getWaitTasks',
    method: 'post',
    data
  })
}
// 获取工单完成情况
export const getOrderCompleteData = (data) => {
  return axios({
    url: '/home/data/getOrderCompleteData',
    method: 'post',
    data
  })
}
// 获取工单构成情况
export const getOrderGroupData = (data) => {
  return axios({
    url: '/home/data/getOrderGroupData',
    method: 'post',
    data
  })
}
// 获取工单类型占比和费用分析
export const getOrderFeeData = (data) => {
  return axios({
    url: '/home/data/getOrderFeeData',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/home/homeData.js